import { useState } from 'react';
import Raven from 'raven-js';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { submitPql } from '../pql/submitPql';
import { loadAndOpenSalesChat } from '../utils/loadAndOpenSalesChat';
import { trackTalkToSalesPql } from '../utils/metricUtils';
import { ReducedOptionsModal } from './ReducedOptionsModal';
import { jsx as _jsx } from "react/jsx-runtime";
const UnassignableModal = ({
  handleIframeSizeChange,
  onClose,
  upgradeData,
  hideBackground,
  modalRoot,
  isUpgradePoint,
  isGD0532ExperimentVariation
}) => {
  const [hasTracked, setHasTracked] = useState(false);
  const onModalView = () => {
    if (!hasTracked) {
      track('communicationMethodsInteraction', Object.assign({
        action: 'viewed unassignable modal'
      }, getUpgradeDataTrackingProperties(upgradeData)));
      submitPql(Object.assign({}, upgradeData, {
        isRetail: false,
        isAssignable: false
      })).catch(error => {
        console.error(error);
        Raven.captureException(new Error('Error submitting PQL with unassignable modal'), {
          extra: {
            error
          }
        });
      });
      trackTalkToSalesPql(upgradeData.app);
      setHasTracked(true);
    }
  };
  const handleClickChatTrack = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked unassignable chat button'
    }, getUpgradeDataTrackingProperties(upgradeData)));
    loadAndOpenSalesChat({
      upgradeData,
      isRetail: false
    });
    onClose({
      isClosedOnOptionsView: false
    });
  };
  const handleClickCallTrack = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked unassignable phone button'
    }, getUpgradeDataTrackingProperties(upgradeData)));
  };
  return /*#__PURE__*/_jsx(ReducedOptionsModal, {
    onModalView: onModalView,
    onClickChat: handleClickChatTrack,
    onClickCall: handleClickCallTrack,
    modalRoot: modalRoot,
    onClose: closeInfo => onClose(closeInfo),
    isRetail: false,
    upgradeData: upgradeData,
    handleIframeSizeChange: handleIframeSizeChange,
    hideBackground: hideBackground,
    isUpgradePoint: isUpgradePoint,
    isGD0532ExperimentVariation: isGD0532ExperimentVariation
  });
};
export default UnassignableModal;